import { render, staticRenderFns } from "./BatteryInfo.vue?vue&type=template&id=5b36f8d1&scoped=true&"
import script from "./BatteryInfo.vue?vue&type=script&lang=js&"
export * from "./BatteryInfo.vue?vue&type=script&lang=js&"
import style0 from "./BatteryInfo.vue?vue&type=style&index=0&id=5b36f8d1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b36f8d1",
  null
  
)

export default component.exports